export default __webpack_public_path__ + "media/pro/amazon-pay@2x-841ba4f7.png";